import React, { useEffect } from "react";
import alert from "../images/alert.svg";
import sucess from "../images/sucess.svg";
import pending from "../images/Pendingicon.svg";
import JointLogo from "./JointLogo";
import { useMyContext } from "../../AppContext";
import { Logout } from "../helper/HeaderMakerforSocket";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { useNavigate } from "react-router-dom";
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function FinalResult() {

  const { Storage, SetStorage } = useMyContext();
const navigate=useNavigate();
  useEffect(() => {
    if(Storage.finalConsentApproval){
      mixpanel.track("Viewed_BS_Success", {
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    }
    else if(Storage.consentpending){
      mixpanel.track("Viewed_BS_Pending", {
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    }
    else {
      mixpanel.track("Viewed_BS_Error", {
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    }
    if(!Storage.consentpending)
    {
    handleLogoutSocket();
    setTimeout(()=>{
      
     if(Storage.redirecttounderreview){
        navigate('/under-review')
     }
     else{
       localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");
     }
      // window.location.href=`/?token=${localStorage.getItem('access_token')}`

      //  window.opener = null;
      //  window.open('', '_self');
      //  window.close();

    },[3000])
  }
  }, []);
 
  const handlegoback=()=>{
    if(Storage.redirecttounderreview){
      setTimeout(()=>{
        navigate('/under-review')
      },[3000])
     }
     else{
       localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");
     }
    handleLogoutSocket();
 
  }
  
  const handleLogoutSocket=()=>{
    
    const userid=Storage.userid;
    Logout.sid=Storage.sessionid;
    const message={
      header:Logout,
      payload:{
        userId:userid
      }
    }
  const Socketconnnection=Storage.Socketconnnection;
  localStorage.removeItem('insession');
  if(!Socketconnnection)
  {
   
    if(Storage.redirecttounderreview){
      setTimeout(()=>{
        navigate('/under-review')
      },[3000])
     }
     else{
       localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");
     }
      
  }
  else{
    Socketconnnection.onclose=()=>{
      localStorage.removeItem('insession');
      toast.error("Session Closed");
      setTimeout(()=>{
        if(Storage.redirecttounderreview){
          navigate('/under-review')
         }
         else{
           localStorage.clear();
           window.open(process.env.REACT_APP_CLOSING_URL, "_self");
         }
      },3000)
    }
   
     Socketconnnection.send(JSON.stringify(message));
     Socketconnnection.onmessage = (event) => {
      const receivedMessage = JSON.parse(event.data);
      if(receivedMessage.status=='SUCCESS'){
        
        if(Storage.redirecttounderreview){
          setTimeout(()=>{
            navigate('/under-review')
          },[3000])
         }
         else{
           localStorage.clear();
           window.open(process.env.REACT_APP_CLOSING_URL, "_self");
         }

        // window.opener = null;
        // window.open('', '_self');
        // window.close();
     }
    }
  }
  }
  return (
    <div className="finalresults">
      <div className="logo">
        <JointLogo />
      </div>

      <div className="content">
        <img src={Storage.finalConsentApproval == 1 ? sucess : (Storage.consentpending?pending:alert)}></img>
        {Storage.finalConsentApproval == 1 ? <h1>Success</h1> : (Storage.consentpending?<h1>Pending</h1>:<h1>Failed</h1>)}

        {Storage.finalConsentApproval == 1 ? (
          <p>
            Thank you! Your bank statement has <br />
            been submitted to ClickMyLoan.
          </p>
        ) : (Storage.consentpending?(
          <p>
         <span className="wait">Please wait</span>
        
          <br></br>
          <br></br>
          <br></br>
        


          Your bank is taking longer than usual
            <br />
            to complete this process.
           
          </p>
        ): (
          <p>
            Seems like there is some technical issue.
            <br />
            Please try again after some time
          </p>
        ))}
      </div>
<div className="myybtn">
{Storage.consentpending?<button className="backbtn" onClick={handlegoback}>Go Back</button>:<></>}
</div>
    </div>
  );
}